import { render, staticRenderFns } from "./DIAGAdocaoSistemaGrupo.vue?vue&type=template&id=201ad5ec&scoped=true&"
import script from "./DIAGAdocaoSistemaGrupo.vue?vue&type=script&lang=js&"
export * from "./DIAGAdocaoSistemaGrupo.vue?vue&type=script&lang=js&"
import style0 from "./DIAGAdocaoSistemaGrupo.vue?vue&type=style&index=0&id=201ad5ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ad5ec",
  null
  
)

export default component.exports